import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import { useAuth } from './../contexts/auth';

// Components
import Header from './../components/Header';

import * as styles from './../styles/PageStyles';

interface User {
  id: string;
  first_name: string,
  last_name: string,
  email: string,
}

const Users = () => {
  const { user, request } = useAuth();

  const [users, setUsers] = useState<User[]>([]);

  const getData = async () => {
    const res = await request('/fellows/unverified', 'GET');
    const data = await res.json();
    setUsers(data);
  }

  const verifyUser = async (id: string) => {
    const res = await request(`/fellows/verify/${id}`, 'POST');
    if (res.ok) {
      getData();
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return <>
    <styles.PageWrapper>
      <Header />

      <styles.Users id="users">
        <h3>Unverified fellows:</h3>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Verify</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => <React.Fragment key={user.id}>
              <tr>
                <td>{user.first_name} {user.last_name}</td>
                <td>{user.email}</td>
                <td><styles.SubtleButton onClick={() => verifyUser(user.id)}>Verify</styles.SubtleButton></td>
              </tr>
            </React.Fragment>)}
          </tbody>
        </table>
      </styles.Users>
    </styles.PageWrapper>
  </>;
}

export default Users;